import {
  ChangeDetectionStrategy,
  Component,
  computed,
  ElementRef,
  HostListener,
  inject,
  input,
  signal,
  ViewChild,
} from '@angular/core';
import { MapListing } from '../../../models/map-listing.model';
import { ListingDetailService } from '../../../services/listing-detail.service';
import { PlannerStore } from '../../../services/planner-store';
import { categoryColor } from '../../map-view/category-pin';

@Component({
  selector: 'app-stop-card',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './stop-card.component.html',
  styleUrl: './stop-card.component.css',
})
export class StopCardComponent {
  private readonly store = inject(PlannerStore);
  private readonly detailService = inject(ListingDetailService);

  readonly stop = input.required<MapListing>();
  readonly index = input.required<number>();
  readonly total = input.required<number>();

  readonly menuOpen = signal(false);

  readonly badgeColor = computed(() => categoryColor(this.stop().category_slug));
  readonly isFirst = computed(() => this.index() === 1);
  readonly isLast = computed(() => this.index() === this.total());

  @ViewChild('menuRoot', { static: false }) menuRoot?: ElementRef<HTMLElement>;

  @HostListener('document:click', ['$event'])
  onDocClick(ev: MouseEvent): void {
    if (!this.menuOpen()) return;
    const root = this.menuRoot?.nativeElement;
    if (root && !root.contains(ev.target as Node)) this.menuOpen.set(false);
  }

  toggleMenu(ev: MouseEvent): void {
    ev.stopPropagation();
    this.menuOpen.update((v) => !v);
  }

  openDetail(): void {
    this.detailService.open(this.stop().id);
  }

  moveUp(ev: MouseEvent): void {
    ev.stopPropagation();
    this.store.moveStop(this.stop().id, 'up');
    this.menuOpen.set(false);
  }

  moveDown(ev: MouseEvent): void {
    ev.stopPropagation();
    this.store.moveStop(this.stop().id, 'down');
    this.menuOpen.set(false);
  }

  remove(ev: MouseEvent): void {
    ev.stopPropagation();
    this.store.removeStop(this.stop().id);
    this.menuOpen.set(false);
  }
}
